import React from "react";
import { Reply } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { SIX_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createRin, createRinVersion, getRinAssets, updateRinMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-032 (EMAILS-SPEC-017/017B): Reply Instructions authoring.
// Same 6-state lifecycle vocabulary and eligibility gate as P.S. -- see
// CRE-SPEC-001 §14.5/§15.10 and ASSET-001 Version 1.4.0. Not the same
// governed concept as Sender Configuration's `reply_to` address
// (BRD-SPEC-001 §10.2) -- this family governs display copy only.
const config = {
  familyCode: "RIN",
  testIdPrefix: "rin",
  idField: "rin_id",
  contentField: "canonical_rin",
  contentLabel: "Canonical Reply Instructions",
  contentInputType: "textarea",
  contentPlaceholder: "e.g. Questions? Simply reply to this email.",
  labelSingular: "Reply Instructions",
  labelPlural: "Reply Instructions",
  icon: Reply,
  statusValues: SIX_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable Reply Instructions line (RIN####).",
  api: {
    list: getRinAssets,
    create: ({ name, status, content }) => createRin({ name, status, canonicalRin: content }),
    createVersion: (id, { version, content }) => createRinVersion(id, { version, canonicalRin: content }),
    updateMetadata: (id, { name, status }) => updateRinMetadata(id, { name, status }),
  },
};

export default function RinPanel() {
  return <AssetFamilyPanel config={config} />;
}
